<template>
  <div class="CandidateIPAnalysisDetails">
    <template>
      <div class="ots-title">
        <p>考试批次：{{ requesttext.planName }}</p>
        <p>考点：{{ requesttext.placeName }}</p>
        <p>场次：{{ requesttext.sessionName }}</p>
        <p>教室：{{ requesttext.className }}</p>
        <p>考试时间:{{ requesttext.beginTime }}~{{ requesttext.endTime }}</p>
      </div>
      <ots-table-group-new
        :tableHeader="tableHeader"
        :tableData="tableData"
        :pagination="pagination"
        @search="search"
        @changeNum="changeSize"
        @changePage="changePage"
      ></ots-table-group-new>
    </template>
  </div>
</template>
<script>
import {
  getIpAnalysisTitleText,
  getIpAnalysisDetailList,
} from "@/http/modules/examSet/section";
export default {
  name: "CandidateIPAnalysisDetails",
  data() {
    return {
      tableData: [],
      tableHeader: [
        {
          title: "座位号",
          prop: "seatNo",
        },
        {
          title: "姓名",
          prop: "realName",
        },
        {
          title: "准考证号",
          prop: "entranceNo",
        },
        {
          title: "身份证号",
          prop: "cardNo",
        },
        {
          title: "IP",
          prop: "sourceIp",
        },
        {
          title: "操作记录",
          prop: "method",
        },
        {
          title: "操作时间",
          prop: "logTime",
        },
        
      ],
      pagination: {
        total: 0,
      },
      requestForm: {
        planClassId: "",
        ip:'',
        size: 10,
        page: 1,
      },
      requesttext: {
        beginTime: "",
        className: "",
        endTime: "",
        placeName: "",
        planName: "",
        sessionName: "",
      },
      planClassId:'',
      sourceIp:''
    };
  },
  methods: {
    search() {
      this.requestForm.planClassId = this.planClassId;
      this.requestForm.ip = this.sourceIp
      getIpAnalysisDetailList(this.requestForm).then((res) => {
        this.pagination.total = res.data.total;
        this.tableData = res.data.records;
      });
      getIpAnalysisTitleText(this.requestForm).then((res) => {
        this.requesttext = res.data;
      });
    },
    changeSize(num) {
      this.requestForm.size = num;
      this.search();
    },
    changePage(p) {
      this.requestForm.page = p;
      this.search();
    },
  },
  created() {
    this.planClassId = this.$route.query.planClassId
    this.sourceIp = this.$route.query.sourceIp
    this.search();
    
  },
};
</script>
<style lang="less" scoped>
.ots-title {
  display: flex;
  justify-content: space-between;
  background: #fff;
  height: 50px;
  line-height: 50px;
  padding: 0 20px;
}
</style>